export default theme => ({
  centered: {
    textAlign: 'center',
  },
  timerWindow: {
    cursor: 'pointer',
    textAlign: 'center',
    width: '100%',
    border: '1px solid black',
    fontSize: '8rem',
  },
  mapContainer: {
    width: '100%',
    height: '25vh',
  },
})



// WEBPACK FOOTER //
// ./src/components/TaskTimer/TaskTimer.styles.js